import es from './es.json'
import en from './en.json'

const languages = { es, en }

export default languages